import { hideCloseBtn } from "../../../js/components/modal";
import { showCloseBtn } from "../../../js/components/modal";
import { defaultSwiperOptions, isMobile } from '../../../js/modules/utilities';

const CURRENT_IMAGE = 'current-image-counter';
const IMAGE_COUNT = 'image-count';

const PHOTO_GALLERY_SWIPER_ID = 'photo-gallery__swiper';
const MOBILE_VIEW_BTN_ID = 'photo-gallery-mobile-view-btn';
const PHOTO_GALLEY_ID = 'photo-gallery';
const MOBILE_BACK_BTN_ID = 'photo-gallery-back-btn';

let imageSwiper;
let imageSlides = [];
let currentImageCounter;
let imageCount;
let mobileViewBtn;
let photoGallery;
let swiper;

const mobileViewClassnames = ['photo-gallery-grid-view', 'photo-gallery-list-view', 'photo-gallery-slider-view'];
const mobileViewOptions = {
  grid: {
    name: 'grid',
    className: mobileViewClassnames[0],
  },
  list: {
    name: 'list',
    className: mobileViewClassnames[1],
  },
  slider: {
    name: 'slider',
    className: mobileViewClassnames[2],
  },
}
let prevMobileView;
let currentMobileView = {
  _value: '',
  get value() {
    return this._value;
  },
  set value(viewOption) {
    prevMobileView = this._value;
    this._value = viewOption;
    updateMobileGalleryView();
  },
};

const onMobileBackBtnClick = (e) => {
  e.stopPropagation();
  currentMobileView.value = prevMobileView;
}

const onImageMobileClick = (e) => {
  e.stopPropagation();
  e.preventDefault();

  currentMobileView.value = mobileViewOptions.slider;
  if (swiper && e.target) {
    swiper.slideTo(e.target.dataset.id);
  }

}

const setCounterValue = (value) => {
  if (currentImageCounter && value) {
    currentImageCounter.innerText = value;
  }
}

const updateMobileGalleryView = () => {
  if (photoGallery) {
    mobileViewClassnames.forEach(className => photoGallery.classList.remove(className))
  }

  if (currentMobileView.value.name === mobileViewOptions.slider.name) {
    if (photoGallery) {
      photoGallery.classList.remove(mobileViewOptions.grid.className);
      photoGallery.classList.remove(mobileViewOptions.list.className);
      photoGallery.classList.add(mobileViewOptions.slider.className);
    }
    hideCloseBtn();
  } else if (currentMobileView.value.name === mobileViewOptions.grid.name) {
    photoGallery.classList.add(mobileViewOptions.grid.className);
    showCloseBtn();
  } else if (currentMobileView.value.name === mobileViewOptions.list.name) {
    photoGallery.classList.add(mobileViewOptions.list.className);
    showCloseBtn();
  }
}

const onMobileViewBtnClick = (e) => {
  e.preventDefault();
  e.stopPropagation();
  if (currentMobileView.value.name === mobileViewOptions.list.name) {
    currentMobileView.value = mobileViewOptions.grid;
  } else if (currentMobileView.value.name === mobileViewOptions.grid.name) {
    currentMobileView.value = mobileViewOptions.list;
  }
}

export const initPhotoGallery = () => {
  imageSwiper = document.getElementById(PHOTO_GALLERY_SWIPER_ID);
  const imageWrapper = document.getElementById('photo-gallery__images');
  if (imageSwiper && imageWrapper) {
    imageSlides = imageSwiper.querySelectorAll('.swiper-slide');
    imageSlides.forEach((slide, i) => {
      const img = slide.firstElementChild.cloneNode(true);
      img.setAttribute('data-id', i);
      img.addEventListener('click', onImageMobileClick);
      imageWrapper.appendChild(img);
    });
    if (!isMobile) {
      const prevDiv = document.createElement('div');
      prevDiv.classList.add('swiper-button-prev');
      const nextDiv = document.createElement('div');
      nextDiv.classList.add('swiper-button-next');
      imageSwiper.appendChild(prevDiv);
      imageSwiper.appendChild(nextDiv);
    }
  }
  currentImageCounter = document.getElementById(CURRENT_IMAGE);
  imageCount = document.getElementById(IMAGE_COUNT);
  mobileViewBtn = document.getElementById(MOBILE_VIEW_BTN_ID);
  photoGallery = document.getElementById(PHOTO_GALLEY_ID);
  const mobileBackBtn = document.getElementById(MOBILE_BACK_BTN_ID);
  if (mobileBackBtn) {
    mobileBackBtn.addEventListener('click', onMobileBackBtnClick);
  }
  if (mobileViewBtn) {
    mobileViewBtn.addEventListener('click', onMobileViewBtnClick);
  }
  if (imageCount && imageSlides) {
    imageCount.innerText = imageSlides.length;
  }
  if (isMobile && imageWrapper) {
    currentMobileView.value = mobileViewOptions.list;
  }
  const swiperOptions = Object.assign({}, defaultSwiperOptions);
  swiperOptions.on = {
    slideChange: (e) => {
      setCounterValue(e.realIndex + 1);
    }
  }
  if (!isMobile) {
    swiperOptions.navigation = {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  }
  setCounterValue(1);
  swiper = new Swiper(imageSwiper, swiperOptions);
}




// WEBPACK FOOTER //
// ./src/templates/components/photo-gallery/photo-gallery.js